export default angular.module('eventix.common.directives.mailgun',[])
    .directive('mailgunVerify', function($http) {
        /**
         * @ngdoc directive
         * @name eventix.common.directives:mailgunVerify
         * @restrict attribute
         * @description
         * Validate an email using [Mailgun validation service](https://documentation.mailgun.com/api-email-validation.html).
         * Remember to set a `MAILGUN_KEY` in your `env` file
         *
         * @param {Function} mailgunVerify
         * Callback which will receive `error{Object}`, `valid{Boolean}` and `suggestion{String}`
         * @param {Any} autocorrect Set this attribute any value to enable autocorrection if
         * the email is invalid and mailgun offers a suggestion
         * @param {Any} ngModel Directive should be added to an input field
         */
        return {
            restrict: 'A',
            require: '?ngModel',
            scope: { mailgunVerify: '&', ngModel: '=', autocorrect: '@' },
            link: function(scope, el, attr, ngModelCtrl) {
                if(!ngModelCtrl || !MAILGUN_KEY || !(MAILGUN_KEY).length)
                    return;
                el.on('blur', function() {
                    $http.get('https://api.mailgun.net/v3/address/validate', {
                        params: {
                            address: scope.ngModel,
                            api_key: MAILGUN_KEY
                        }
                    }).then(res => {
                        if(res.data.did_you_mean && attr.autocorrect)
                            scope.ngModel = res.data.did_you_mean;
                        if(!res.data.is_valid) {
                            return scope.mailgunVerify({
                                error: null,
                                valid: false,
                                suggestion: res.data.did_you_mean
                            });
                        }
                        return scope.mailgunVerify({
                            error: null,
                            valid: true,
                            suggestion: null
                        });
                    }, err => {
                        return scope.mailgunVerify({
                            error: err
                        });
                    });
                });
            }
        };
    }).name;
